


























































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { component } from "../../api/component/component";
import { personnel } from "../../api/personnel/personnel";
import { alarm } from "../../api/alarm/alarm";
import { status } from "../../api/status/status";
import { shifts } from "../../api/shifts/shifts";
import AlarmFiltersReports from "../Filters/AlarmFiltersReports.vue";
import Moment from "moment";
import { StringHelpers } from "../../api/helpers/StringHelpers";
@Component({
  name: "AlarmList",
  components: {
    AlarmFiltersReports
  }
})
export default class AlarmList extends Vue {
  public alarmList: any[] = [];
  public statusList: any[] = [];
  public personnelList: any[] = [];
  public componentList: any[] = [];
  public loading: boolean = false;
  public filters: any = {};
  public typeList: any[] = [];
  public tableData: any[] = [];
  public listEnd: boolean = false;
  public index: number = 0;
  public more() {
    let i = 1;
    while (i < 10) {
      this.tableData.push(
        this.alarmList[this.alarmList.length - 1 - this.index - i]
      );
      this.index++;
      i++;
      if (
        this.alarmList[this.alarmList.length - 1 - this.index - i] == undefined
      ) {
        this.index--;
        this.listEnd = true;
        return;
      }
    }
  }
  public getDateTime(row: any) {
    if (row.date_started === undefined) {
      return "";
    }
    return Moment(row.date_started).format("DD/MM/YYYY HH:mm");
  }
  public getShift(row: any) {
    if (row.poster[0].level < 2) {
      return row.poster[0].name.split(" ")[1];
    }
    if (
      new Date(row.date_started).getHours() >= 14 &&
      new Date(row.date_started).getHours() < 22
    ) {
      return "Evening " + row.poster[0].name.split(" ")[1];
    }
    if (
      new Date(row.date_started).getHours() >= 6 &&
      new Date(row.date_started).getHours() < 14
    ) {
      return "Morning " + row.poster[0].name.split(" ")[1];
    }
    return "Night " + row.poster[0].name.split(" ")[1];
  }
  public async getPersonnelList() {
    await personnel
      .getAllPersonnel(
        this.$store.getters.getToken,
        this.$store.getters.getHost
      )
      .then(response => {
        response.json().then(resp => {
          this.personnelList = JSON.parse(JSON.stringify(resp));
          console.log(this.personnelList);
          this.getStatusList();
        });
      });
  }
  public getComponentName(row: any, column: any): String {
    console.log(row);
    let component = this.componentList.find(
      (obj: any) => obj.id === row.componentIds[0]
    );
    if (component != undefined) {
      return component.literal;
    }
    return "";
  }
  public getHall(row: any, column: any): String {
    console.log(row);
    let component = this.componentList.find(
      (obj: any) => obj.id === row.componentIds[0]
    );
    if (component != undefined) {
      return component.group1;
    }
    return "";
  }
  public getStatus(row: any, column: any): String {
    console.log(row);
    let status = this.statusList.find((obj: any) => obj.id === row.status);
    if (status != undefined) {
      return status.literal;
    }
    return "";
  }
  public chopDescription(row: any, column: any): String {
    return StringHelpers.shorten(row.name);
  }
  public getFilters() {
    let a = [];
    {
      for (const s of this.statusList) {
        a.push({ value: s.id, text: s.literal });
      }
    }
    return a;
  }
  public async search() {
    this.loading = true;
    this.listEnd = false;
    console.log(this.filters);
    if (this.filters.dateFrom === null) {
      delete this.filters.dateFrom;
    }
    if (this.filters.dateTo === null) {
      delete this.filters.dateTo;
    }
    await alarm
      .getSomeAlarms(
        this.$store.getters.getToken,
        this.filters,
        this.$store.getters.getHost
      )
      .then(response => {
        response.json().then((resp: any) => {
          this.alarmList = JSON.parse(JSON.stringify(resp));
          this.tableData = this.alarmList.slice(
            this.alarmList.length - 10,
            this.alarmList.length
          );
          this.loading = false;
          console.log("1response of Alarm list------>"+JSON.stringify(resp))
          console.log("2response of Alarm list------>"+JSON.parse(resp))
          console.log("3response of Alarm list------>"+JSON.parse(JSON.stringify(resp)));
        });
      });
  }
  public fillTable() {
    for (const w of this.alarmList) {
      //w.personnel = JSON.parse(w.personnel);
    }
    console.log(this.alarmList);
  }
  public alarmStatus({
    row,
    rowIndex
  }: {
    row: number;
    rowIndex: number;
  }): String {
    return this.getStatus(row, 1);
  }
  public async created() {
    this.loading = true;
    await this.getPersonnelList();
  }
  public filterHandler(value: any, row: any, column: any) {
    const property = column["property"];
    return row[property] === value;
  }
  public handleClick(rowIndex: number, row: any) {
    row.personnel = JSON.stringify(row.personnel);
    this.$store.dispatch("updateCurrentObject", row);
    this.$store.dispatch("setCurrentId", row.id);
    this.$store.dispatch("updateCurrentComponent", "AddAlarm");
    this.$router.replace({
      name: "load"
    });
  }
  public filterDate(date: any) {
    if (date === undefined) {
      return "";
    }
    return Moment(date).format("DD/MM/YYYY");
  }
  public filterDateTime(date: any) {
    if (date === undefined) {
      return "";
    }
    return Moment(date).format("DD/MM/YYYY HH:mm");
  }
  public async getComponentList() {
    await component
      .getAllComponents(
        this.$store.getters.getToken,
        this.$store.getters.getHost
      )
      .then(response => {
        response.json().then(resp => {
          this.componentList = JSON.parse(JSON.stringify(resp));
          this.getShiftTypeList();
        });
      });
    this.fillTable();
  }
  public async getShiftTypeList() {
    await shifts
      .getShiftTypes(this.$store.getters.getToken, this.$store.getters.getHost)
      .then(response => {
        response.json().then((resp: any) => {
          this.typeList = JSON.parse(JSON.stringify(resp));
          this.loading = false;
        });
      });
  }
  public async getAlarmList() {
    await alarm
      .getAllAlarms(this.$store.getters.getToken, this.$store.getters.getHost)
      .then(response => {
        response.json().then((resp: any) => {
          this.alarmList = JSON.parse(JSON.stringify(resp));
        });
      });
  }
  public async getStatusList() {
    await status
      .getAllStatuses(this.$store.getters.getToken, this.$store.getters.getHost)
      .then(response => {
        response.json().then((resp: any) => {
          this.statusList = JSON.parse(JSON.stringify(resp));
          this.getComponentList();
        });
      });
  }
  public async deleteAlarm(rowIndex: number, row: any) {
    await alarm
      .recycleAlarm(
        this.$store.getters.getToken,
        row.id,
        this.$store.getters.getHost
      )
      .then(async r => {
        if (r.status == 400) {
          this.$message.error(r.error);
        } else {
          this.$message("Alarm Recycled");
          this.search();
        }
      });
  }
}
